import {cartActionTypes} from '../actions/cart-action-types';
import paymentAccountActionTypes from "../../account/actions/payment-accounts-action-types";

const initialCartState = {
    id: null,
    customerOrderNo: '',
    orderType: '',
    numCartItems: null,
    orderTotal: null,
    orderSubTotal: null,
    totalDiscount: null,
    taxTotal: null,
    tax1Label: null,
    tax2Label: null,
    taxPct: null,
    tax1Pct: null,
    tax2Pct: null,
    tax1Total: null,
    tax2Total:null,
    shippingHandlingTotal: null,
    preferredShippingMethod: '',
    billingSameAsShipping: true,
    promotionCode: '',
    promotionDescription: '',
    orderStatus: '',
    orderStatusDate: '',
    isDirectToDvd: null,
    isDigitizingOrder: null,
    lineItems: [],
    selectedPaymentAccount: {
        id: -1
    },
    hasUserMadeDigitizingChoice: false,
    cartDataReceived: false,
    hasUserMadeAIChoice: false,
    includesEnhancement: false

};

export const cart = (state = initialCartState, action) => {
    switch (action.type) {
        case cartActionTypes.CART_RECEIVED:
            return {...state, ...action.element, cartDataReceived: true};
        case cartActionTypes.CART_QTY_UPDATE: {
            let lineItems = [].concat(state.lineItems);
            for (var i = 0; i < lineItems.length; i++) {
                if (lineItems[i].id === action.value.itemId) {
                    lineItems[i].unitQty = action.value.qty;
                    break;
                }
            }
            let newCart = Object.assign({}, state);
            newCart.lineItems = lineItems;
            return newCart;
        }
        case cartActionTypes.CART_PROCESS_TYPE_CHOICE_MADE:
            return {...state, hasUserMadeDigitizingChoice: true}
        case cartActionTypes.CART_TOGGLE_PROCESS_TYPE:
            return {...state, isDirectToDvd: !state.isDirectToDvd, hasUserMadeDigitizingChoice: true}
        case cartActionTypes.CART_PROCESS_AI_CHOICE_MADE:
            return {...state, hasUserMadeAIChoice: true}
        case cartActionTypes.CART_TOGGLE_AI_TYPE:
            return {...state, isEnhance: action.isEnhance, hasUserMadeAIChoice: true}
        case cartActionTypes.CART_UPDATE_CHECKOUT: {
            let newFieldState = {...state}
            newFieldState[action.element.field] = action.element.value;
            return newFieldState;
        }
        case cartActionTypes.CART_UPDATE_SHIPPING: {
            //let newShippingState = Object.assign({}, state);
            return {...action.element,
                cartDataReceived: true,
                preferredShippingMethod: state.preferredShippingMethod,
                selectedPaymentAccount: state.selectedPaymentAccount,
                hasUserMadeDigitizingChoice: state.hasUserMadeDigitizingChoice,
                isDirectToDvd: state.isDirectToDvd,
                billingSameAsShipping: state.billingSameAsShipping,
            };
            // let newShippingState = {...state};
            // newShippingState.shippingHandlingTotal = action.element.shippingHandlingTotal;
            // newShippingState.orderTotal = action.element.orderTotal;
            // newShippingState.orderSubTotal = action.element.orderSubTotal;
            // newShippingState.taxTotal = action.element.taxTotal;
            // newShippingState.taxLabel = action.element.taxLabel;
            // newShippingState.tax1Label = action.element.tax1Label;
            // newShippingState.tax2Label = action.element.tax2Label;
            // newShippingState.tax1Pct = action.element.tax1Pct;
            // newShippingState.tax2Pct = action.element.tax2Pct;
            // newShippingState.tax1Total = action.element.tax1Total;
            // newShippingState.tax2Total = action.element.tax2Total;
            // newShippingState.totalDiscount = action.element.totalDiscount;
            // newShippingState.balanceDue = action.element.balanceDue;
            // return newShippingState;
        }
        case cartActionTypes.CART_CHECKOUT_FAILED: {
            let errMsg = "Failed to process order - ";
            if (action.error.errorMessage != null) {
                errMsg = action.error.errorMessage;
            } else if (Array.isArray(action.error.errors)) {
                for (let i = 0; i < action.error.errors.length; i++) {
                    if (i > 0) {
                        errMsg += ", ";
                    }
                    errMsg += action.error.errors[i].field + ": " + action.error.errors[i].message;
                }
            }
            return {...state, checkoutSuccess: false, checkoutMessage: errMsg}
        }
        case cartActionTypes.CART_CHECKOUT_SUCCESS: {
            //wipe out the cart state
            return {
                id: null,
                lineItems: [],
                checkoutSuccess: true,
                lastCheckoutId: state.id,
                selectedPaymentAccount: {id: -1},
                cartDataReceived: true
            }
        }
        case cartActionTypes.CART_FAILED:
            return {...state, errors: action.error}
        case cartActionTypes.CART_CHECKOUT_ACKNOWLEDGED: {
            let st = Object.assign(state);
            delete st.checkoutSuccess;
            delete st.checkoutMessage;
            delete st.errors;
            return st;
        }
        case cartActionTypes.DEFAULT_PAYMENT_CHANGED: {
            return {...state, selectedPaymentAccount: action.defaultPayment};
        }
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/cart/reducers/cart-reducers.js